import { Box, Paper } from "@mui/material"
import PropTypes from "prop-types"
import SearchableMenu from "components/searchable-menu"
import { SEARCHABLE_MENU_ITEM } from "helpers/shapes"

export default function FactorsSubscreenSelector({ menuItems, selectedScreen, selectedSubScreen, selectScreen }) {
  const handleSelectSubScreen = (subscreen) => {
    const { id } = subscreen
    selectScreen(`${selectedScreen}/${id}`, selectedSubScreen)
  }

  return <Paper square className="screen-menu-container">
    <Box className="screen-menu-container">
      <SearchableMenu items={menuItems} current={selectedSubScreen} onSelect={handleSelectSubScreen} hideSearchBox className="analyze-composite-select-subscreen" />
    </Box>
  </Paper>
}

FactorsSubscreenSelector.propTypes = {
  selectedScreen: PropTypes.string.isRequired,
  selectedSubScreen: PropTypes.string.isRequired,
  selectScreen: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM).isRequired,
}
